/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './package-subscription.reducer';

export const PackageSubscription = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const packageSubscriptionList = useAppSelector(state => state.packageSubscription.entities);
  const loading = useAppSelector(state => state.packageSubscription.loading);
  const totalItems = useAppSelector(state => state.packageSubscription.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="package-subscription-heading" data-cy="PackageSubscriptionHeading">
        <Translate contentKey="tinyMedicRestApp.packageSubscription.home.title">Package Subscriptions</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.packageSubscription.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/package-subscription/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.packageSubscription.home.createLabel">Create new Package Subscription</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.packageSubscription.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {packageSubscriptionList && packageSubscriptionList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('validFrom')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.validFrom">Valid From</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('validFrom')} />
                </th>
                <th className="hand" onClick={sort('validTill')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.validTill">Valid Till</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('validTill')} />
                </th>
                <th className="hand" onClick={sort('remindFrom')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.remindFrom">Remind From</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('remindFrom')} />
                </th>
                <th className="hand" onClick={sort('lockOutOn')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.lockOutOn">Lock Out On</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lockOutOn')} />
                </th>
                <th className="hand" onClick={sort('paidAmount')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.paidAmount">Paid Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('paidAmount')} />
                </th>
                <th className="hand" onClick={sort('pendingAmount')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.pendingAmount">Pending Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('pendingAmount')} />
                </th>
                <th className="hand" onClick={sort('expired')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.expired">Expired</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expired')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('subscriptionNumber')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.subscriptionNumber">Subscription Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('subscriptionNumber')} />
                </th>
                <th className="hand" onClick={sort('suspended')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.suspended">Suspended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspended')} />
                </th>
                <th className="hand" onClick={sort('suspendedReason')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.suspendedReason">Suspended Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspendedReason')} />
                </th>
                <th className="hand" onClick={sort('suspendedDate')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.suspendedDate">Suspended Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspendedDate')} />
                </th>
                <th className="hand" onClick={sort('suspendedBy')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.suspendedBy">Suspended By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suspendedBy')} />
                </th>
                <th className="hand" onClick={sort('paymentStatus')}>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.paymentStatus">Payment Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('paymentStatus')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.scheme">Scheme</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.packageSubscription.billToAddress">Bill To Address</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {packageSubscriptionList.map((packageSubscription, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/package-subscription/${packageSubscription.id}`} color="link" size="sm">
                      {packageSubscription.id}
                    </Button>
                  </td>
                  <td>{packageSubscription.validFrom}</td>
                  <td>{packageSubscription.validTill}</td>
                  <td>{packageSubscription.remindFrom}</td>
                  <td>{packageSubscription.lockOutOn}</td>
                  <td>{packageSubscription.paidAmount}</td>
                  <td>{packageSubscription.pendingAmount}</td>
                  <td>{packageSubscription.expired ? 'true' : 'false'}</td>
                  <td>{packageSubscription.active ? 'true' : 'false'}</td>
                  <td>{packageSubscription.lastUpdated}</td>
                  <td>{packageSubscription.microSec}</td>
                  <td>{packageSubscription.timestampEntry}</td>
                  <td>{packageSubscription.cursor}</td>
                  <td>{packageSubscription.subscriptionNumber}</td>
                  <td>{packageSubscription.suspended ? 'true' : 'false'}</td>
                  <td>{packageSubscription.suspendedReason}</td>
                  <td>{packageSubscription.suspendedDate}</td>
                  <td>{packageSubscription.suspendedBy}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PaymentStatus.${packageSubscription.paymentStatus}`} />
                  </td>
                  <td>
                    {packageSubscription.scheme ? (
                      <Link to={`/payment-scheme/${packageSubscription.scheme.id}`}>{packageSubscription.scheme.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {packageSubscription.billToAddress ? (
                      <Link to={`/contact-details/${packageSubscription.billToAddress.id}`}>{packageSubscription.billToAddress.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/package-subscription/${packageSubscription.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/package-subscription/${packageSubscription.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/package-subscription/${packageSubscription.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.packageSubscription.home.notFound">No Package Subscriptions found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={packageSubscriptionList && packageSubscriptionList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PackageSubscription;
